import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Search, X } from 'lucide-react';

interface FilterValues {
  search: string;
  role: string;
}

interface UserFilterSidebarProps {
  filters: FilterValues;
  onFilterChange: (key: keyof FilterValues, value: string) => void;
  onClearFilters: () => void;
}

export function UserFilterSidebar({
  filters,
  onFilterChange,
  onClearFilters,
}: UserFilterSidebarProps) {
  const hasActiveFilters = filters.search !== '' || filters.role !== '';

  return (
    <div className="w-64 space-y-4 p-4 border rounded-lg bg-card">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold">الفلاتر</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            className="h-8 px-2 text-muted-foreground"
          >
            <X className="h-4 w-4 ms-1" />
            مسح
          </Button>
        )}
      </div>

      {/* Search */}
      <div className="space-y-2">
        <Label>البحث</Label>
        <div className="relative">
          <Search className="absolute end-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="اسم، بريد، هاتف..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="pe-9"
          />
        </div>
      </div>

      {/* Role Filter */}
      <div className="space-y-2">
        <Label>الدور</Label>
        <Select
          value={filters.role || 'all'}
          onValueChange={(value) => onFilterChange('role', value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="جميع الأدوار" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">جميع الأدوار</SelectItem>
            <SelectItem value="admin">مدير النظام</SelectItem>
            <SelectItem value="carrier">ناقل</SelectItem>
            <SelectItem value="driver">سائق</SelectItem>
            <SelectItem value="tenant">عميل</SelectItem>
            <SelectItem value="customer">مستلم</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
